// 未登录状态下的头部
<template>
  <span
    class="consult-buy"
    :class="{ active: isActive == 3 }"
    @click="goConsultBuy"
    ><i
      class="el-icon-shopping-cart-2"
      style="font-size: 16px; margin-right: 5px"
    ></i
    >咨询与购买</span
  >
</template>

<script>
export default {
  props: ["isActive"],
  methods: {
    goConsultBuy() {
      this.$router.push("/pricing");
    },
  },
};
</script>

<style lang="scss" scoped>
.active {
  background-color: #206184;
}
.consult-buy {
  // width: 110px;
  display: inline-block;
  height: 60px;
  line-height: 60px;
  color: #f1f1f1;
  float: right;
  cursor: pointer;
  padding: 0 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/common/buttonBuy.vue